<template>
    <el-drawer
        title="修改接收人"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="500px"
        @close="close"
    >
        <div class="drawer-content">
            <el-form                
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
            >
                <el-form-item label="当前受赠人手机号:" >
					+{{formDatas.acceptUserAreaCode}} {{formDatas.acceptUserTelephone}}                    
                </el-form-item>                
				<el-form-item prop="telephone" label="新受赠人手机号:" :rules="[{required: true, message: '请输入手机号'}]">
				    <el-input class="input-with-select" v-model.trim="formDatas.telephone" placeholder="请输入手机号" maxlength="20" size="medium" style="display: inline-table;">
				        <el-select v-model="formDatas.areaCode" slot="prepend" placeholder="请选择区号">
				            <el-option v-for="(item,index) in countryList" :key="index" :label="`+${item.code}`" :value="item.codeView">
				                +{{item.code}} {{item.name}}
				            </el-option>
				        </el-select>
				    </el-input>					
				</el-form-item>
            </el-form>
			
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllCountry} from '@/assets/js/commonApi';
const defaultFormData = {
    ticketCodeId:'',
    areaCode:'86_CN',
    telephone:'',
	
}
export default {
    data(){
        
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas: {
                ...defaultFormData,
            },
            rules:{
                areaCode:[{required: true, message: '请选择区号'}],
				telephone:[{required: true, message: '请输入手机号'}],                
            },
			countryList:null,
			itemData:null,
           
        }
    },
    computed:{
        
    },
	created(){	   
	    this.getCountryList();
	},
    methods:{
        close(){
            this.formDatas = { ...defaultFormData };
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
        },
        show(data,sort,index){
            this.itemData = {...data};
            this.formDatas = {
                ...defaultFormData,
				...data
            }
			this.sort = sort;
			this.index = index;
            this.drawerShow = true;			
        },
		//获取所有国家（区号）
		async getCountryList(){
		    const res = await fetchAllCountry({}).catch(() => {});
		    const{ state, result} = res.data;
		    if( state == 1 ){
		        this.countryList = result;
				
		    }
		},
        
        submitForm(){            
			let self = this;			
			self.$refs["formDatas"].validate((valid) => {
			    if (valid) {			       
			        this.btnLoading = true;
			        this.$request({
			            url:"/activiOrder/updateAcceptUser",
			            params: {
							ticketCodeId:this.formDatas.ticketCodeId,
							areaCode:this.formDatas.areaCode,
							telephone:this.formDatas.telephone
						},
			            method: "post",
			        })
			            .then((res) => {
			                const { state, msg } = res.data;
			                if (state == 1) {
			                    this.$emit('onUpdate');								
			                    self.close();
			                } else {
			                    self.$message.error(msg || "操作失败,请重试");
			                }
			            })
			            .catch(() => {
			                self.$message.error("操作失败,请重试");
			            })
			            .finally(() => {
			                this.btnLoading = false;
			            });
			    } else {
			        return false;
			    }
			});
			
			
        }
    }
}
</script>
<style lang="scss" scoped>
.el-select .el-input {
	width: 130px;
  }
  .input-with-select .el-input-group__prepend {
	background-color: #fff;
  }
</style>